export { default } from "./link";
export type { LinkProps } from "./types";
